module.exports = __webpack_public_path__ + "img/save.6b546b73.svg";